<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <div
            v-if="projection && projection.producer.cuit !== null && projection.producer.cuit !== ''"
            class="d-inline-block mr-2"
          >
            <router-link
              v-if="projection && $can('store', 'orders') && canAssignOrder"
              :to="{
                name: 'OrderCreate',
                query: {
                  projection: projection.id,
                  producer: projection.producer.id,
                  campaign: projection.campaign.id,
                },
              }"
              class="btn base-button btn-neutral btn-sm mt-1"
              >Asignar Pedido
            </router-link>
          </div>
          <div v-else class="d-inline-block mr-2">
            <button class="btn base-button btn-neutral btn-sm mt-1" @click="validateProducer">Asignar Pedido</button>
          </div>
          <div v-if="projection && $can('store', 'quotations') && !isProjectionConfirmed" class="d-inline-block">
            <router-link
              :to="{
                name: 'QuotationCreate',
                query: {
                  projection: projection.id,
                  producer: projection.producer.id,
                  campaign: projection.campaign.id,
                },
              }"
              class="btn base-button btn-neutral btn-sm mt-1"
            >
              Cotizar
            </router-link>
          </div>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <projection-data :projection="projection" />
        </div>
      </div>
      <div class="row">
        <div v-if="!isProjectionConfirmed && $can('store', 'projection_activities')" class="col-md-5 col-sm-12">
          <activities-form ref="activitiesForm" :server-errors="serverErrors" @save="saveProjectionActivity">
          </activities-form>
        </div>
        <div
          v-if="$can('index', 'projection_activities')"
          :class="{ 'col-md-12': isProjectionConfirmed, 'col-md-7': !isProjectionConfirmed }"
          class="col-sm-12"
        >
          <activities-list ref="activitiesList" :projection="projection" />
        </div>
      </div>
      <div v-if="$can('index', 'orders')" class="row">
        <div class="col-md-12 col-sm-12">
          <orders-list
            :projection-id="projectionId"
            :is-projection-confirmed="isProjectionConfirmed"
            :can-associate-order="canAssociateOrder"
            @freezeOrders="freezeOrders"
          />
        </div>
      </div>
      <div v-if="$can('index', 'quotations')" class="row">
        <div class="col-md-12 col-sm-12">
          <quotations-list :projection-id="projectionId" :is-projection-confirmed="isProjectionConfirmed" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProjectionData from '@/views/Projection/Show/ProjectionData';
import ActivitiesList from '@/views/Projection/Activities/List';
import ActivitiesForm from '@/views/Projection/Activities/Form';
import OrdersList from '@/views/Projection/List/OrdersList';
import QuotationsList from '@/views/Projection/List/QuotationsList';
import swal from 'sweetalert2';

export default {
  name: 'ProjectionsShow',
  components: {
    RouteBreadCrumb,
    ProjectionData,
    ActivitiesList,
    QuotationsList,
    ActivitiesForm,
    OrdersList,
  },

  data() {
    return {
      projectionId: null,
      isDataLoaded: false,
      projection: null,
      serverErrors: [],
      canAssignOrder: true,
    };
  },

  computed: {
    isProjectionConfirmed() {
      return this.projection.state !== null && this.projection.state.name === 'confirmed';
    },

    canAssociateOrder() {
      return (
        this.projection.orders.length === 0 && this.projection.state !== null && this.projection.state.name !== 'danger'
      );
    },
  },

  mounted() {
    this.projectionId = +this.$route.params.id;
    this.fetchProjection();
  },

  methods: {
    fetchProjection() {
      const params = {
        include: ['variety.crop', 'campaign.crops', 'producer', 'orders'],
      };
      this.$services
        .resource('projections')
        .show(this.projectionId, params)
        .then((res) => res.data.data)
        .then((projection) => {
          this.projection = projection;
          this.isDataLoaded = true;
          this.canAssignOrder = !this.isProjectionConfirmed;
        });
    },

    saveProjectionActivity(projectionActivity) {
      this.$services
        .resource('projection_activities')
        .setProjection(this.projection.id)
        .create(projectionActivity)
        .then((res) => res.data.data)
        .then((data) => {
          this.afterSave(data);
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },

    afterSave(newActivity) {
      this.$refs.activitiesList.addActivity(newActivity);
      this.$refs.activitiesForm.cleanForm();
      this.fetchProjection();
    },

    freezeOrders() {
      this.canAssignOrder = false;
    },

    validateProducer() {
      const canEditProducers = this.$can('update', 'producers');
      swal({
        title: 'Productor no valido',
        text: canEditProducers
          ? 'Primero debe completar el CUIT del productor. Desea completarlo ahora?'
          : 'No se pueden asignar ordenes a productores sin CUIT.',
        confirmButtonClass: 'btn btn-primary',
        type: 'warning',
        showCancelButton: canEditProducers,
        confirmButtonText: canEditProducers ? 'Sí' : 'Ok',
        buttonsStyling: false,
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value && canEditProducers) {
          this.$router.push({
            name: 'ProducerEdit',
            params: { id: this.projection.producer.id },
            query: { projection: this.projection.id },
          });
        }
      });
    },
  },
};
</script>
